import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import { pipelineOptionFromEntity } from 'components/forms/autocomplete/Pipeline';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormTags from 'components/forms/FormTags';
import FormAutocomplete from 'components/forms/FormAutocomplete';

class LeadCatcherAdvancedRouteDetails extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['advancedRouting', props.index];
  }

  render() {
    const {
      intl: { messages },
      data,
      index,
      disabled,
    } = this.props;

    return (
      <Row>
        <Col xs={12} md={6}>
          <div className="panel panel-transparent">
            <div className="panel-body">
              <p className="form-group-title">Route {index + 1}</p>
              <div className="form-group-attached">
                <FormTags
                  label={messages.tags}
                  name="tags"
                  value={data.getTags()}
                  meta={data.getTagsMetaInformation()}
                  validation={data.getTagsValidationResult()}
                  onChange={this.updateEntity}
                  disabled={disabled}
                  messages={messages}
                />
                <FormAutocomplete
                  label={messages.pipeline}
                  name="pipeline"
                  value={pipelineOptionFromEntity(data.getPipeline())}
                  meta={data.getPipelineMetaInformation()}
                  validation={data.getPipelineValidationResult()}
                  onChange={this.updateEntity}
                  returnValueObject
                  autocompleteType="pipeline"
                  disabled={disabled}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

export default injectIntl(LeadCatcherAdvancedRouteDetails);
